import { DBv2, Table } from "@kosmod/pancake/kitchen"
import { Room, RoomID, RoomInternal } from "./room"
import { GameID, Player, PlayerID } from "@kosmod/sesame"

export type ConciergeDB = DBv2.OfDB<typeof ConciergeDB> //{
  // players: DBv2.Table<Player, ['game', 'id']>,

  // rooms: DBv2.Table<Room, ['game', 'id']>,
  // roomsInternal: DBv2.Table<RoomInternal, ['game', 'id']>,
  // roomInGame: DBv2.Index<Room, ['game']>,
  
  // playersInRoom: DBv2.Table<PlayerID, [GameID, RoomID, PlayerID]>,
//}

export const ConciergeDB = DBv2.def({
  rooms: {
    name: 'concierge/rooms',
    shape: Room,
    primaryKeys: ['game', 'id'],
    indices: {
      byGame: { indexKeys: ['game'] }
    }
  },
  roomsInternal: {
    name: 'concierge/rooms-internal',
    shape: RoomInternal,
    primaryKeys: ['game', 'id'],
    indices: {
      byGame: { indexKeys: ['game'] }
    }
  },
})